import { render, staticRenderFns } from "./SurfacePostMoreActions.vue?vue&type=template&id=5c4031df&scoped=true&"
import script from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
export * from "./SurfacePostMoreActions.vue?vue&type=script&lang=ts&"
import style0 from "./SurfacePostMoreActions.vue?vue&type=style&index=0&id=5c4031df&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c4031df",
  null
  
)

export default component.exports